import actions from 'state/constants';
import initialState from 'state/initialState';
import { StoreLocationUtils } from 'utils/StoreLocation';

const fetchStoreLocationReducer = state => ({
  ...state,
  ...state.storesContent,
  isStoreLocationContentBegin: false,
});

const fetchedStoreLocationReducer = (state, action) => {
  return {
    ...state,
    ...state.storesContentByHandle,
    storesContentByHandle:
      StoreLocationUtils.transformArrayIntoObjectByHandle(action?.payload) || {},
    isStoreLocationContentBegin: true,
    errorMessage: action?.error || null,
  };
};

export const reducer = (state = initialState.storeLocation, action) => {
  switch (action.type) {
    case actions.FETCH_STORE_LOCATION_REQUEST:
      return fetchStoreLocationReducer(state, action);
    case actions.FETCH_STORE_LOCATION_SUCCESS:
    case actions.FETCH_STORE_LOCATION_FAILURE:
      return fetchedStoreLocationReducer(state, action);

    default:
      return state;
  }
};

export default reducer;
